//退款上传图片的service
{
    angular.module('utilsModule')
        .factory('utils.refundUploadManager', refundUploadManager);
    refundUploadManager.$inject = ['utils.constant','FileUploader','$state'];
    function refundUploadManager(constant,FileUploader,$state) {
        let collect={
            'uploader':null,
            'init':init,
            'callbackDelegateList':[],
            'imageList':[]
        }

        function init(){
            if(collect.uploader){
                return;
            }
            let uploader = collect.uploader=new FileUploader({
                url: constant.config.sitePath+constant.action.refundUpload,
                // formData:[{'a':0,'b':1}],
                alias :'Filedata'//alias 别名
            });

            uploader.filters.push({
                name: 'imageFilter',
	            fn: function(item /*{File|FileLikeObject}*/, options) {
	                var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	            }
            });

            // CALLBACKS
            function doCallback(funcName,...args){
                // console.log('doCallback',collect.callbackDelegateList.length);
                for(let i=0;i<collect.callbackDelegateList.length;i++){
                    // console.log(typeof(collect.callbackDelegateList[i].onProgressItem));
                    if(typeof(collect.callbackDelegateList[i][funcName])=='function'){
                        collect.callbackDelegateList[i][funcName](...args);
                    }
                }
            }
            uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
                // console.info('onWhenAddingFileFailed', item, filter, options);
                doCallback('onWhenAddingFileFailed',item, filter, options);
            };
            uploader.onAfterAddingFile = function(fileItem) {
                // console.info('onAfterAddingFile', fileItem);
                // console.info(uploader.queue);
                fileItem.upload();
                doCallback('onAfterAddingFile',fileItem);
            };
            uploader.onAfterAddingAll = function(addedFileItems) {
                // console.info('onAfterAddingAll', addedFileItems);
            };
            uploader.onBeforeUploadItem = function(item) {
                // console.info('onBeforeUploadItem', item);
            };
            uploader.onProgressItem = function(fileItem, progress) {
                // console.info('onProgressItem', fileItem, progress);
                doCallback('onProgressItem',fileItem, progress);
            };
            uploader.onProgressAll = function(progress) {
                // console.info('onProgressAll', progress);
            };
            uploader.onSuccessItem = function(fileItem, response, status, headers) {
                // console.info('onSuccessItem', fileItem, response, status, headers);
                console.log(response);

                collect.imageList.push({
                    "name":response.name,
                    "path":constant.config.sitePath+constant.config.refundImagePath+response.name
                });
                doCallback('onSuccessItem',fileItem, response, status, headers);
            };
            uploader.onErrorItem = function(fileItem, response, status, headers) {
                // console.info('onErrorItem', fileItem, response, status, headers);
                
                doCallback('onErrorItem',fileItem, response, status, headers);
            };
            uploader.onCancelItem = function(fileItem, response, status, headers) {
                // console.info('onCancelItem', fileItem, response, status, headers);
                
                doCallback('onCancelItem',fileItem, response, status, headers);
            };
            uploader.onCompleteItem = function(fileItem, response, status, headers) {
                // console.info('onCompleteItem', fileItem, response, status, headers);
            };
            uploader.onCompleteAll = function() {
                // console.info('onCompleteAll');
            };

            // console.info('uploader', uploader);
        }


        return collect;
    }

}